// extracted by mini-css-extract-plugin
export var dividerLine = "_5h-3";
export var itemImage = "_5h-9";
export var lightDivider = "_5h-4";
export var modalContent = "_5h-5";
export var modalContentCompact = "_5h-6";
export var productCard = "_5h-a";
export var productImage = "_5h-b";
export var productImageCompact = "_5h-7";
export var productImagePlaceholder = "_5h-c";
export var productImagePlaceholderCompact = "_5h-8";
export var progressBarBackground = "_5h-1";
export var progressBarContainer = "_5h-0";
export var progressBarFill = "_5h-2";